import getErrorData from './getErrorData';

export default function getErrorCode(error: Error)
{
    return getErrorData(error)?.error;
}
